'use strict';

// сохранить в памяти выбранное животное
export function SetGlobalClient(client)
{ 
    localStorage.setItem('client_ID', client.ID);
    localStorage.setItem('client_name', client.name);
    localStorage.setItem('client_address', client.address);
}
export function GetGlobalClient()
{ 
    var client = [];
    client.ID = localStorage.getItem('client_ID');
    client.name = localStorage.getItem('client_name');
    client.address = localStorage.getItem('client_address');
    if(client.name === undefined || client.name == null) client.name = "";
    return client;
}
export function ClearGlobalClient()
{ 
    localStorage.removeItem('client_ID');
    localStorage.removeItem('client_name');
    localStorage.removeItem('client_address');
}

export default SetGlobalClient;